"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealHourlyWageCalculator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var TopiaInput_1 = require("./TopiaInput");
var helpers_1 = require("../helpers");
var Card_1 = require("./Card");
function RealHourlyWageCalculator(props) {
    var _a = __read((0, react_1.useState)({
        hoursPerMonth: 4,
    }), 2), state = _a[0], setState = _a[1];
    return ((0, jsx_runtime_1.jsxs)(Card_1.Card, { className: "", children: [(0, jsx_runtime_1.jsxs)("p", { className: "mb-4 text-md text-white", children: ["Is it worth it? Let's calculate your", (0, jsx_runtime_1.jsx)("span", { className: "font-bold", children: " Real Hourly Wage " }), "from this hustle"] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col-reverse gap-4 md:flex-row md:items-center", children: [(0, jsx_runtime_1.jsx)(TopiaInput_1.TopiaTextInput, { label: "Hours per month", inputProps: {
                            value: state.hoursPerMonth,
                            onChange: function (ev) {
                                setState(function (s) { return (__assign(__assign({}, s), { hoursPerMonth: Number(ev.target.value) })); });
                            },
                            type: "number",
                        } }), (0, jsx_runtime_1.jsx)("div", { className: "flex-1" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-col items-center justify-center text-center", children: [(0, jsx_runtime_1.jsxs)("p", { className: "text-2xl font-bold text-future-blue", children: [(0, helpers_1.formatCurrency)(props.monthlyProfit / state.hoursPerMonth), (0, jsx_runtime_1.jsx)("sub", { children: "/hr" })] }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-topia-gray", children: "Real hourly wage" })] })] })] }));
}
exports.RealHourlyWageCalculator = RealHourlyWageCalculator;
